import React from 'react';

function Profile() {
    return (
        <>
            <h2>User Profile (Placeholder)</h2>
            <p><strong>First Name:</strong> Mang </p>
            <p><strong>Last Name:</strong> Kanor </p>
            <p><strong>Email:</strong> Mang@gmail.com</p>
            <p><strong>Mobile Number:</strong> 09662674344</p>
            <p><strong>Home Address:</strong> 420 Wow st, Manila</p>
        </>
    );
}

export default Profile;
